export const NONE = 'none';
export const NEW = 'new';
export const OPEN = 'open';
export const EXPORT = 'export';
export const THEME = 'theme';